import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr";

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreateInvestorFile, GetInvestorFileById, UpdateInvestorFile } from "services/api/module/SustainabilityPerformanceFile"
import ModalContext from "../../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import InputText from "components/Input/InputText";
import DatePicker from "react-datepicker";
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE
const _routePermission = `sustainability-performance:file-list`

const SustainabilityPerformanceFileTemplate = ({
  pageView = "create"
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = qParams.id
  const navigate = useNavigate();

  const [list, setList] = useState([
    { id: 1, name: 'Item 1' },
    { id: 2, name: 'Item 2' },
    { id: 3, name: 'Item 3' },
    { id: 4, name: 'Item 4' }
  ]);

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentSubject: Yup.string().max(255).required("Please Enter หัวข้อ"),
    activityDate: Yup.string().max(255).required("Please Enter Activity Date"),
    // contentDetail: Yup.string().max(255).required("Please Enter รายละเอียด"),
    // linkUrl: Yup.string().max(512).required("Please Enter ลิ้งค์"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string().max(1024).required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string().max(1024).required("Please Enter Meta Description"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),


  })


  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentSubject: "",
    activityDate: "",
    // contentDetail: "",
    // linkUrl: "",
    contentFile: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",


  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ InvestorFileCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentSubject: values.contentSubject,
        activityDate: values.activityDate,
        // contentDetail: values.contentDetail,
        // linkUrl: values.linkUrl,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {

        },

        contentAttachmentData: {
          file: values.contentFile,
        }
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      if (pageView === "update") {
        API.fetchUpdateInvestorFile(payload)
      } else {
        API.fetchCreateInvestorFile(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentSubject", resData?.contentSubject ?? "")
    validation.setFieldValue("activityDate", resData?.activityDate ?? "")
    // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    // validation.setFieldValue("linkUrl", resData?.linkUrl ?? "")
    validation.setFieldValue("contentFile", resData?.contentFile ?? "")

    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  }

  const API = {
    fetchGetInvestorFileById: async (payload) => {
      try {
        const response = await GetInvestorFileById({ id: payload.id, lang: qLang })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      }
      catch (err) {
        console.log('err ', err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      }
    },
    fetchCreateInvestorFile: async (payload) => {
      try {
        const response = await CreateInvestorFile({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/home/investor-file/${qLang}`)
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      }
    },
    fetchUpdateInvestorFile: async (payload) => {
      try {
        const response = await UpdateInvestorFile({ data: payload, id: payload.id, lang: qLang })
        const resData = response.data
        if (resData.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              navigate(`/home/investor-file/${qLang}`)
            },
          })
        }
      }
      catch (err) {
        console.log('err ', err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      API.fetchGetInvestorFileById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `Investor File | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: '10px',
    border: '1px solid black',
    margin: '5px',
    borderRadius: '8px',
    background: '#f9f9f9',
    transition: 'transform 0.2s ease, background-color 0.3s ease',
  };

  const mapValues = (list = []) => list.map(item => {
    const newObj = {
      attachmentId: item.attachmentId,
      sequence: item.sequence
    }
    return newObj
  })

  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} Investor File`}
            breadcrumbItems={[
              { title: "Investor File", link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          <Row>
            <Col className="col-12">
              <FormikProvider value={validation}>
                <Form
                  className="form-horizontal"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col className="col-8">
                      <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                          <i className='bx bx-cube-alt'></i> Information Box
                        </h5>
                        <CardBody>
                          <Row>
                          <Col md={4}>
                              <label
                                htmlFor="category_name"
                                className="col-md-12 col-form-label"
                              >
                                Document Date
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <DatePicker
                                    dateFormat="yyyy-mm-dd"
                                    id="activityDate"
                                    className={`form-control ${validation.touched.activityDate && validation.errors.activityDate ? 'is-invalid' : ''}`}
                                    name="activityDate"
                                    autoComplete="off"
                                    selected={moment().format('YYYY-MM-DD')}
                                    onChange={date => {
                                        validation.setFieldValue(
                                            "activityDate",
                                            moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
                                        )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={moment(validation.values.activityDate).format('YYYY-MM-DD')}
                                    invalid={
                                        validation.touched.activityDate &&
                                            validation.errors.activityDate
                                            ? true
                                            : false
                                    }
                                    disabled={pageView === "view"}
                                />
                                {validation.touched.activityDate &&
                                    validation.errors.activityDate && (
                                        <FormFeedback className=" d-block" type="invalid">
                                            {validation.errors.activityDate}
                                        </FormFeedback>
                                    )}
                              </div>
                              <hr/>
                            </Col>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="category_name"
                                className="col-md-12 col-form-label"
                              >
                                หัวข้อ
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <InputText
                                  id="contentSubject"
                                  className="form-control"
                                  type="text"
                                  placeholder=""
                                  name="contentSubject"

                                  onChange={(e) => {
                                    validation.setFieldValue("contentSubject", e.target.value)
                                    // validation.setFieldValue("contentSeoTitle", e.target.value)
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.contentSubject}
                                  invalid={validation.touched.contentSubject && validation.errors.contentSubject ? true : false}
                                  disabled={pageView === "view"}
                                  maxLength={9999}
                                  errorText={validation.errors.contentSubject}
                                />
                              </div>
                            </Col>
                            {/* <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    รายละเอียด
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentDetail"
                                      className="form-control"
                                      type="textarea"
                                      rows="3"
                                      placeholder=""
                                      name="contentDetail"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentDetail}
                                      invalid={ validation.touched.contentDetail && validation.errors.contentDetail ? true: false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentDetail && validation.errors.contentDetail && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentDetail}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col> */}
                            {/* <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    ลิ้งค์
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="linkUrl"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="linkUrl"
                                    
                                      onChange={(e) => {
                                        validation.setFieldValue("linkUrl", e.target.value)
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.linkUrl}
                                      invalid={validation.touched.linkUrl && validation.errors.linkUrl ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.linkUrl && validation.errors.linkUrl && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.linkUrl}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col> */}
                            <Col className="col-12 mb-3">
                              {/* {JSON.stringify(validation.values.contentFile)} */}
                              <div className="col-md-12">
                                <PopupAttachment
                                  typeDetail="single"
                                  upload="PDF"
                                  typeUpload="PDF"
                                  prefixName="investor-file"
                                  label="PDF"
                                  required={true}
                                  description="description"
                                  widthSize={576}
                                  heightSize={721}
                                  value={validation.values.contentFile}
                                  onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('contentFile', value)
                                  }}
                                  onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('contentFile', {})
                                  }}
                                />
                                {validation.touched.contentFile && validation.errors.contentFile && (
                                  <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.contentFile}
                                  </div>
                                )}
                              </div>
                              <hr />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col className="col-4">
                      <Card outline color="primary" className="border sticky-element">
                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                          <i className='bx bx-check'></i> Tools Box
                        </h5>
                        <CardBody>
                          <Row>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="category_name"
                                className="col-md-12 col-form-label"
                              >
                                Switch Language
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <InputLang widthfull pageView={pageView} forceRoute={false} />
                              </div>
                            </Col>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="category_name"
                                className="col-md-12 col-form-label"
                              >
                                Written at
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <InputGroup>
                                  <Flatpickr
                                    className="form-control d-block"
                                    options={{
                                      dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                    }}
                                    value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                    disabled={true}
                                  />
                                  <div className="input-group-append">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary docs-datepicker-trigger"
                                      disabled
                                    >
                                      <i className="fa fa-calendar" aria-hidden="true" />
                                    </button>
                                  </div>
                                </InputGroup>
                                {
                                  (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                    <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                  )
                                }
                              </div>
                            </Col>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="category_name"
                                className="col-md-12 col-form-label"
                              >
                                Display
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <Select
                                  placeholder="Select Status"
                                  value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                  onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                  getOptionValue={(option) => option.id}
                                  getOptionLabel={(option) => option.name}
                                  options={STATUS_OPTION}
                                  className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                  isDisabled={pageView === "view"}
                                />
                                {
                                  (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                    <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                  )
                                }
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <Row>
                            <Col className="text-start">
                              <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/home/investor-file/${qLang}`)}>Back</Button>
                            </Col>
                            <Col className="text-end">
                              {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                            </Col>
                          </Row>
                        </CardFooter>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              </FormikProvider>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(SustainabilityPerformanceFileTemplate)
